import { ALL_CHANNELS } from "../constants/Channels";
import { uniq } from "lodash";

export default {
  methods: {
    getFormValidationError() {
      let el = document.querySelector(
        ".v-form .v-text-field__details .error--text"
      );
      if (el) {
        if (el && el.innerText !== "") {
          return el.innerText;
        } else {
          var span = document.createElement("span");
          span.innerHTML = el.innerHTML;
          return span.textContent || span.innerText;
        }
      }
    },
    copyToClipboard(txt) {
      let tempInput = document.createElement("input");
      tempInput.value = txt;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
    },
    getChannelConstObj(name) {
      if (name === ALL_CHANNELS.name) {
        return ALL_CHANNELS;
      }
      const found = this.$constants.Channels.CHANNELS.find((channel) => {
        return channel.name == name;
      });
      return found || { name: name, label: name, img: "" };
    },
    getChannelConstObjById(id) {
      const found = this.$constants.Channels.CHANNELS.find((channel) => {
        return channel.id == id;
      });
      return found;
    },
    getOtp(order) {
      const channelObj = this.getChannelConstObj(order.source);
      if (
        channelObj.name === this.$constants.Channels.ZOMATO.name &&
        order.customer_mobile
      ) {
        return order.customer_mobile.substr(
          order.customer_mobile.length - 4,
          4
        );
      }
      if (
        channelObj.name === this.$constants.Channels.SWIGGY.name &&
        order.swiggy_customer_id
      ) {
        return order.swiggy_customer_id.substr(
          order.swiggy_customer_id.length - 4,
          4
        );
      }
      if (channelObj.name === this.$constants.Channels.WHATSAPP.name) {
        return order.pickup_otp;
      }
    },

    getOrderStatusConstObj(id) {
      const found = this.$constants.OrderStatuses.STATUSES.find((status) => {
        return status.id == id;
      });
      return found || { id, value: "", label: "", color: "" };
    },
    getBatchLabel(val) {
      const found = this.$constants.Batches.BATCHES.find((status) => {
        return status.value == val;
      });
      return found ? found.label : val;
    },
    getDishTypeConstObj(data) {
      let value = "";
      if (Array.isArray(data)) {
        if (data.length) {
          value = data[0];
        } else {
        }
      } else if (data && (typeof data === "string" || data instanceof String)) {
        value = data;
      }
      const found = this.$constants.dishTypes.DISH_TYPES.find((dishType) => {
        return dishType.value == value;
      });
      return found || { value: value, label: value, img: "" };
    },
    isURL(str) {
      return /^(?:(?:https?:\/\/)?(?:www\.)?)?([^\s\/?#]+\.[^\s\/?#]+)(?:\/[^\s?#]*)?(?:\?[^\s#]*)?(?:#[^\s]*)?$/.test(
        str
      );
    },
    formatDigit(n, length) {
      if (n == null) {
        return "";
      }
      let numberLength = n.toString().length;
      if (numberLength >= 5) {
        return n;
      }
      var len = length - ("" + n).length;
      return (len > 0 ? new Array(++len).join("0") : "") + n;
    },
    formatDate: function (d, withTime, onlyTime) {
      if (d == null) {
        d = new Date();
      }
      if (!d) {
        return "";
      }
      var date = new Date(d);
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      if (withTime) {
        return (
          this.formatDigit(date.getDate(), 2) +
          "-" +
          this.formatDigit(date.getMonth() + 1, 2) +
          "-" +
          date.getFullYear() +
          " " +
          strTime
        );
      } else if (onlyTime) {
        return strTime;
      } else {
        return (
          this.formatDigit(date.getDate(), 2) +
          "-" +
          this.formatDigit(date.getMonth() + 1, 2) +
          "-" +
          date.getFullYear()
        );
      }
    },
    formatText: function (s) {
      if (!s) {
        return "";
      }
      var words = s.split("_");
      var text = "";
      for (var i = 0; i < words.length; i++) {
        text += words[i][0].toUpperCase() + words[i].slice(1) + " ";
      }
      return text;
    },
    convertCelsiusToFahrenheit(temp) {
      return Number(temp) * (9 / 5) + 35;
    },
    getFormattedTimeDifference(d1, d2) {
      let seconds = this.getDateTimeDifferenceInSeconds(d1, d2);
      return seconds < 60
        ? `${seconds} Sec`
        : seconds % 60 < 30
        ? `${Math.floor(seconds / 60)} Min`
        : `${Math.ceil(seconds / 60)} Min`;
    },
    getTimeDifferenceInDays(d1, d2) {
      let seconds = this.getDateTimeDifferenceInSeconds(d1, d2);
      return Math.floor(seconds / (60 * 60 * 24));
    },
    getTimeDifferenceInMinute(d1, d2) {
      let seconds = this.getDateTimeDifferenceInSeconds(d1, d2);
      return seconds % 60 < 30
        ? Math.floor(seconds / 60)
        : Math.ceil(seconds / 60);
    },
    getDateTimeDifferenceInSeconds(d1, d2) {
      let fromTime = d1 ? new Date(d1) : new Date();
      let toTime = d2 ? new Date(d2) : new Date();
      let diff = toTime.getTime() - fromTime.getTime();
      return Math.floor(diff / 1000);
    },
    getDateDifferenceInDays(d1, d2) {
      return Math.ceil(
        this.getDateTimeDifferenceInSeconds(d1, d2) / (60 * 60 * 24)
      );
    },
    getMinutesFromFormattedTime(value) {
      if (value && typeof value == "string") {
        const timeSplit = value.split(":");
        return Number(timeSplit[0]) * 60 + Number(timeSplit[1]);
      } else {
        return value;
      }
    },
    getFormattedTimeFromMinute(val) {
      const min = val % 60;
      let hrs = (val - min) / 60;
      return `${hrs.toString().padStart(2, "0")}:${min
        .toString()
        .padStart(2, "0")}`;
    },
    getFormattedTimeFromMinuteWithMeridiem(val) {
      const min = val % 60;
      let hrs = (val - min) / 60,
        a = "";
      if (hrs > 12) {
        hrs -= 12;
        a = "PM";
      } else {
        a = "AM";
      }
      return `${hrs.toString().padStart(2, "0")}:${min
        .toString()
        .padStart(2, "0")} ${a}`;
    },
    convertTime12to24(time12h) {
      if (!time12h) return "";
      const [time, modifier] = time12h?.split(" ");
      let [hours, minutes] = time?.split(":");
      hours === "12"
        ? (hours = "00")
        : modifier === "PM" || modifier === "pm"
        ? (hours = parseInt(hours, 10) + 12)
        : "";
      return `${hours}:${minutes}`;
    },
    convertTime24to12(time24h) {
      if (time24h && typeof time24h == "string") {
        const timeSplit = time24h.split(":");
        if (Number(timeSplit[0]) <= 12) {
          if (timeSplit[0] == 0) {
            return `12:${timeSplit[1]} AM`;
          }
          return `${time24h} AM`;
        } else {
          return `${(timeSplit[0] - 12).toString().padStart(2, "0")}:${
            timeSplit[1]
          } PM`;
        }
      } else {
        return "_ _";
      }
    },
    requestPermission() {
      this.notificationRequestDialog = false;
      if (window.isSecureContext && Notification) {
        Notification.requestPermission();
      }
    },

    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    getThumbnail(file) {
      try {
        return URL.createObjectURL(file);
      } catch (error) {
        return file;
      }
    },

    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },

    getBoolean(val) {
      return !val || val == "false" ? false : true;
    },

    printElement(el) {
      let divContents = document.getElementById(el).innerHTML;
      var a = window.open("", "", "height=800, width=800");
      a.document.write(
        '<html><style>@page { size: A4 }</style><body onload="window.print()">'
      );
      a.document.write(divContents);
      a.document.write("</body></html>");
      a.document.close();
    },
    printPage() {
      window.print();
    },
    checkPrintPageBreak(index, length, printRownsInPage, rowsOccupiedByHeader) {
      return (
        index &&
        index + 1 < length &&
        (index <= printRownsInPage - rowsOccupiedByHeader
          ? index % (printRownsInPage - rowsOccupiedByHeader) == 0
          : (index + rowsOccupiedByHeader) % printRownsInPage == 0)
      );
    },
    getPrintPaginationText(
      index,
      length,
      printRownsInPage,
      rowsOccupiedByHeader
    ) {
      return `Page ${Math.ceil(
        (index + rowsOccupiedByHeader) / printRownsInPage
      )} of ${Math.ceil(
        (length - 1 + rowsOccupiedByHeader) / printRownsInPage
      )}`;
    },
    roundNumberWithTwoDecimal(n) {
      return Math.round(n * 100) / 100;
    },
    /**
     * Finds list of all combos where the item is a part of
     */
    findCombos(combosList, menuItem, variants = []) {
      let combos = [];
      if (variants.length) {
        variants.forEach((variant) => {
          combos = [...combos, ...this.combosFound(combosList, variant)];
        });
      } else {
        combos = this.combosFound(combosList, menuItem);
      }
      return uniq(combos);
    },

    combosFound(combosList, item) {
      let combos = [];
      for (let index = 0, n = combosList.length; index < n; index++) {
        const isComboFound = combosList[index].combo_items.find(
          (element) => element.comboable_id === item.id
        );
        if (isComboFound) {
          combos.push(combosList[index].id);
        }
      }
      return combos;
    },

    getCombosFromItemsList(items) {
      let combos = [];
      items.forEach((item) => {
        if (item.combo?.id) {
          const comboIndex = combos.findIndex((combo) => {
            return item.combo.id == combo.id;
          });
          if (comboIndex < 0) {
            combos.push({
              ...item.combo,
              items: [item],
              quantity: item.quantity,
              item_total: item.item_total
            });
          } else {
            combos[comboIndex].items.push(item);
          }
        }
      });
      return combos;
    },
    getItemsExcludingCombos(items) {
      return items.filter((item) => !item.combo);
    },
    getItemListWithItemsAndCombos(items) {
      return [
        ...this.getCombosFromItemsList(items),
        ...this.getItemsExcludingCombos(items)
      ];
    },
    getUpdatedUnavailableItems(unavailableItems, toggledItem) {
      let order = unavailableItems.find(
        (item) => item.orderId === toggledItem.orderId
      );
      const index = order.items.indexOf(toggledItem.itemId);
      if (toggledItem.isAvailable && index !== -1) {
        order.items.splice(index, 1);
      } else {
        order.items.push(toggledItem.itemId);
      }
      return unavailableItems;
    },
    isAndroid() {
      return !!window.Android;
    },
    async getCategoryDeleted(selectedCategory) {
      try {
        await this.deleteCategory(selectedCategory.id);
        await this.getCategories({ forceFetch: true });
        this.$nuxt.$emit("show-toast", {
          text: "Category removed successfully",
          color: "success darken-2",
          icon: "done",
          flat: true
        });
      } catch (err) {
        this.$nuxt.$emit("show-error-toast", err);
      }
    },
    moveItemsToCategory(data) {
      if (data.destinationCategory) {
        const isSubcategory = !!data.destinationCategory.parent_id;
        const itemIds = this.menuUploadList
          .filter((item) => {
            return item.sub_category_id === data.id;
          })
          .map((item) => item.id);
        this.SET_MENU_UPLOAD_LIST_PROP({
          ids: itemIds,
          propName: "category_id",
          propValue: isSubcategory
            ? data.destinationCategory.parent_id
            : data.destinationCategory.id,
          subPropName: isSubcategory ? "sub_category_id" : null,
          subPropValue: isSubcategory ? data.destinationCategory.id : null
        });
      } else {
        const isSubcategory = !!data.parent_id;
        const itemIds = this.menuUploadList
          .filter((item) => {
            return item.category_id === this.selectedCategory.id;
          })
          .map((item) => item.id);
        this.SET_MENU_UPLOAD_LIST_PROP({
          ids: itemIds,
          propName: "category_id",
          propValue: isSubcategory ? data.parent_id : data.id,
          subPropName: isSubcategory ? "sub_category_id" : null,
          subPropValue: isSubcategory ? data.id : null
        });
      }
    },
    blobToBase64(blob) {
      if (!blob) return;
      return new Promise((resolve, _) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    },
    async dataUrlToFile(dataUrl, fileName) {
      const res = await fetch(dataUrl);
      const blob = await res.blob();
      return new File([blob], fileName, { type: "image/png" });
    },
    addScript({ src, async = false, defer = false, crossorigin = "" }) {
      return new Promise((resolve, reject) => {
        const el = document.createElement("script");
        el.setAttribute("src", src);
        el.setAttribute("async", async);
        el.setAttribute("defer", defer);
        el.setAttribute("crossorigin", crossorigin);
        el.addEventListener("load", resolve);
        el.addEventListener("error", reject);
        document.body.prepend(el);
      });
    },
    formattedOtpTimer(otpTimer) {
      let seconds = otpTimer % 60;
      let minutes = (otpTimer - seconds) / 60;
      return `${minutes <= 9 ? "0" : ""}${minutes} : ${
        seconds <= 9 ? "0" : ""
      }${seconds}`;
    },
    getWhatsappOrderUrl(ph) {
      return `https://wa.me/${ph}?text=Hi`;
    },
    hasDayChanged(prevTimestamp, currentTimestamp) {
      const prevDate = new Date(prevTimestamp).toLocaleDateString();
      const currentDate = new Date(currentTimestamp).toLocaleDateString();
      return prevDate !== currentDate;
    },
    getItemDiscountedPrice(item) {
      if (item?.combo_items) {
        return item.item_final_discounted_price;
      } else {
        if (item.item_final_price === null) {
          if (item.variants && item.variants.items) {
            const lowestPriceVariant = item.variants.items.reduce(
              (minVariant, currentVariant) =>
                currentVariant.price < minVariant.price
                  ? currentVariant
                  : minVariant,
              item.variants.items[0]
            );

            return lowestPriceVariant.whatsapp_discounted_price;
          } else {
            return null;
          }
        } else {
          return item.item_final_discounted_price;
        }
      }
    },
    getItemPrice(item) {
      if (item?.combo_items) {
        return item.amount;
      } else {
        if (item.item_final_price === null) {
          if (item.variants && item.variants.items) {
            const lowestPriceVariant = item.variants.items.reduce(
              (minVariant, currentVariant) =>
                currentVariant.price < minVariant.price
                  ? currentVariant
                  : minVariant,
              item.variants.items[0]
            );

            return lowestPriceVariant.price;
          } else {
            return null;
          }
        } else {
          return item.item_final_price;
        }
      }
    },

    getReturnOtp(orderDetails) {
      return this.getChannelConstObj(orderDetails.source).name ===
        this.$constants.Channels.WHATSAPP.name
        ? orderDetails.return_otp
        : orderDetails.rider_status?.order_return_otp;
    },
    getApplicableMaxCharge(item, isBulkUpload = true) {
      if (!item) return;
      let price = isBulkUpload ? item.price : item.item_price;

      const getVariantWithLeastPrice = (variants) => {
        if (!variants || variants.length === 0) return price;

        const sortedVariants = [...variants].sort((a, b) => a.price - b.price);
        return sortedVariants[0].price;
      };

      if (isBulkUpload && item.variants) {
        price = getVariantWithLeastPrice(item.variants);
      } else if (item?.variants?.items?.length > 0) {
        price = getVariantWithLeastPrice(item.variants.items);
      }

      const applicableSlab = !isNaN(price)
        ? this.$constants.PackagingSlabs.PACKAGING_SLABS.find(
            (slab) => price <= slab.max
          )
        : null;
      return applicableSlab?.maxCharge;
    },
    getMenuUploadItemIndex(menuUploadList, itemId) {
      const index = menuUploadList.findIndex((item) => item.id === itemId);
      return index;
    },
    flattenedAttributes(selectedAttributes) {
      const flattenAttributes = (attributes, level = 0, parentId = null) => {
        return attributes.reduce((acc, attr) => {
          acc.push({
            ...attr,
            level,
            parent_id: parentId
          });
          if (attr.subAttributes && attr.subAttributes.length > 0) {
            const subAttributes = flattenAttributes(
              attr.subAttributes,
              level + 1,
              attr.id
            );
            acc = acc.concat(subAttributes);
          }
          return acc;
        }, []);
      };
      return flattenAttributes(selectedAttributes);
    },
    getImagePath(imageSrc) {
      return `${window.location.origin}${imageSrc}`;
    },
    itemOptions(item) {
      let toAdd = [];
      if (item && Array.isArray(item.options_to_add)) {
        for (let j = 0; j < item.options_to_add.length; j++) {
          toAdd.push(item.options_to_add[j].title);
        }
      }
      return toAdd;
    },
    getQuantity(item) {
      const isCombo = !!item.items?.length;
      const quantity = parseFloat(
        isCombo ? item.combo_quantity : item.quantity
      );
      const unit = item.price_unit === "kilograms" ? "kg" : "";

      return `${quantity}${unit}`;
    },
    getItemName(item) {
      let itemOptionsToAdd = this.itemOptions(item);
      // combining item name and options
      let itemString = "";
      if (itemOptionsToAdd.length) {
        itemString =
          (item.item_name || item.name) + "- " + itemOptionsToAdd.join(", ");
      } else {
        itemString = item.item_name || item.name;
      }
      if (item.combo?.id) itemString += ` (COMBO : ${item.combo.name})`;
      return itemString;
    },
    isHtmlPrintingEnabled() {
      return (
        // !this.isAndroid() &&
        this.getBoolean(this.$ls.get("html-printing", false))
      );
    },
    getHighlightedText(text, highlightedText) {
      highlightedText = "";
      this.highlightText.split("").forEach((char) => {
        let index = text.toLowerCase().indexOf(char);
        if (index >= 0) {
          highlightedText += text.substring(0, index);
          highlightedText += `<span class="primary--text">${text[index]}</span>`;
          text = text.substring(index + 1);
        }
      });
      highlightedText += text;
      return highlightedText;
    },
    getFormattedDeliveryAddress(data) {
      return `${data?.house_number}, ${data?.address}`;
    }
  }
};
